import React from "react"
import Image from "next/image"
import { Bed, Bath, ScanTextIcon } from "lucide-react"
import Link from "next/link"

import { Tag } from "@/components/atoms/Tag"
import FeaturedImg from "@/assets/images/feature-property.jpg"
import { formatDisplayPrice } from '@/utils/index'

function PropertyCard({
  bedrooms,
  bathrooms,
  squareFeet,
  price,
  title,
  listedIn,
  category,
  images,
  location,
  id,
}: any) {
  const href = `/property/${id}`
  const linkAria = `Visit Property: ${title}`
  const formattedLocation = [location?.city !== "Unknown City" ? location?.city : null, location?.state, location?.country]
    .filter(Boolean)
    .join(", ")

  return (
    <Link
      className="shadow-1 group flex h-full w-full flex-col overflow-hidden rounded-lg rounded-tr-[90px] bg-slate-50 p-5 transition first-line:overflow-hidden hover:shadow-2xl dark:bg-gray-950"
      aria-label={linkAria}
      href={href}
    >
      <div className="relative mb-8 aspect-[4/3] overflow-hidden rounded-lg">
        <Image
          src={images[0] || FeaturedImg}
          alt={title}
          className="rounded-lg rounded-bl-[90px] rounded-tr-[90px] object-cover transition-transform group-hover:z-40 group-hover:scale-105"
          fill
        />
      </div>

      <div className="mb-4 flex justify-between">
        <div className="flex gap-x-2">
          <Tag bgColor={"bg-orange-500"} textColor={"text-white"} label={listedIn} />
          <Tag bgColor={"bg-blue-600"} textColor={"text-white"} label={category?.name || category} />
          <Tag
            bgColor={"bg-black"}
            textColor={"text-white"}
            label={location?.state || location?.city || location?.country || ""}
          />
        </div>
      </div>
      <div className="mx-w-[260px] text-lg font-semibold capitalize">{title}</div>
      <p className="font-light text-neutral-400">{formattedLocation}</p>
      <div className="my-4 flex gap-x-4">
        <div className="flex items-center gap-1 border-r-2 border-gray-500 pr-5 text-gray-600 dark:text-gray-300">
          <div className="pt-1">{bedrooms}</div>
          <div className="align-middle text-[20px]">
            <Bed />
          </div>
        </div>
        <div className="flex items-center gap-1 border-r-2 border-gray-500 pr-5 text-gray-600 dark:text-gray-300">
          <div className="pt-1">{bathrooms}</div>
          <div className="text-[20px]">
            <Bath />
          </div>
        </div>
        <div className="flex items-center justify-center gap-1  text-gray-600 dark:text-gray-300">
          <div className="text-[20px]">
            <ScanTextIcon />
          </div>
          <div className="pt-1">{squareFeet} Sqft</div>
        </div>
      </div>
      <div className="mb-4 text-lg font-semibold text-black dark:text-white">{formatDisplayPrice(price)}</div>
    </Link>
  )
}

export default PropertyCard
